/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_No_Company_AlertInputs */

const en_company_jobs_no_company_alert = /** @type {(inputs: Company_Jobs_No_Company_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No company assigned. Please complete the company profile first.`)
};

const de_company_jobs_no_company_alert = /** @type {(inputs: Company_Jobs_No_Company_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Firma zugeordnet. Bitte zuerst Firmenprofil ausfüllen.`)
};

/**
* | output |
* | --- |
* | "No company assigned. Please complete the company profile first." |
*
* @param {Company_Jobs_No_Company_AlertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_no_company_alert = /** @type {((inputs?: Company_Jobs_No_Company_AlertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_No_Company_AlertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_no_company_alert(inputs)
	return en_company_jobs_no_company_alert(inputs)
});